import { memo } from 'react';
import { LinearProgress } from '@material-ui/core';

export const Loading = memo(LinearProgress);
